/**
 * Created by Sunny on 2016/4/5.
 */
//levelObj:贵族等级，privilege特权
module.exports = {
    levelObj: [
        {
            level: 0,
            name:'平民',
            totalScore: 50,
            get_score:0,
            safeScore: 0,
            minusScors: 0,
            privilege: [],
            num: {
                flower: 3,
                color: '天蓝色'
            }
        },
        {
            level: 1,
            name:'富民',
            totalScore: 50,
            get_score:50,
            safeScore: 10,
            minusScors: 30,
            privilege: [9, 10, 16, 7, 11],
            num: {
                flower: 3,
                color: '天蓝色'
            }
        }, {
            level: 2,
            name:'财主',
            totalScore: 100,
            get_score:100,
            safeScore: 10,
            minusScors: 30,
            privilege: [9, 10, 16, 7, 11],
            num: {
                flower: 3,
                color: '天蓝色'
            }
        }, {
            level: 3,
            name:'富贾',
            totalScore: 100,
            get_score:	200,
            safeScore: 10,
            minusScors: 60,
            privilege: [9, 10, 16, 7, 11],
            num: {
                flower: 3,
                color: '天蓝色'
            }
        }, {
            level: 4,
            name:'富商',
            totalScore: 200,
            get_score:	300,
            safeScore: 10,
            minusScors: 60,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 6,
                color: '天蓝色',
                expression: 3
            }
        }, {
            level: 5,
            name:'富翁' ,
            totalScore: 500,
            get_score:	500,
            safeScore: 50,
            minusScors: 120,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 6,
                color: '天蓝色',
                expression: 3
            }
        }, {
            level: 6,
            name:'巨富',
            totalScore: 1000,
            get_score:	1000,
            safeScore: 100,
            minusScors: 300,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 6,
                color: '天蓝色',
                expression: 3
            }
        }, {
            level: 7,
            name:'富豪',
            totalScore: 1000,
            get_score:	2000,
            safeScore: 150,
            minusScors: 600,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 9,
                color: '天蓝色',
                expression: 3
            }
        }, {
            level: 8,
            name:'勋爵',
            totalScore: 1000,
            get_score:	3000,
            safeScore: 200,
            minusScors: 600,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 9,
                color: '红色',
                expression: 3
            }
        }, {
            level: 9,
            name:'男爵',
            totalScore: 1000,
            get_score:	4000,
            safeScore: 300,
            minusScors: 600,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 9,
                color: '红色',
                expression: 3
            }
        }, {
            level: 10,
            name:'子爵',
            totalScore: 5000,
            get_score:	5000,
            safeScore: 500,
            minusScors: 600,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 9,
                color: '红色',
                expression: 5
            }
        }, {
            level: 11,
            name:'伯爵',
            totalScore: 10000,
            get_score:	10000,
            safeScore: 1000,
            minusScors: 3000,
            privilege: [8, 9, 10, 16, 7, 11],
            num: {
                flower: 12,
                color: '红色',
                expression: 5
            }
        }, {
            level: 12,
            name:'侯爵',
            totalScore: 10000,
            get_score:	20000,
            safeScore: 2000,
            minusScors: 6000,
            privilege: [6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 12,
                color: '红色',
                expression: 5
            }
        }, {
            level: 13,
            name:'公爵',
            totalScore: 10000,
            get_score:	30000,
            safeScore: 3000,
            minusScors: 6000,
            privilege: [6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 12,
                color: '红色',
                expression: 5
            }
        }, {
            level: 14,
            name:'王爵',
            totalScore: 20000,
            get_score:	40000,
            safeScore: 4000,
            minusScors: 6000,
            privilege: [4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 15,
                color: '红色',
                expression: 5
            }
        }, {
            level: 15,
            name:'郡王',
            totalScore: 20000,
            get_score:	60000,
            safeScore: 6000,
            minusScors: 12000,
            privilege: [4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 15,
                color: '玫红色',
                expression: 5
            }
        }, {
            level: 16,
            name:'藩王',
            totalScore: 20000,
            get_score:	80000,
            safeScore: 8000,
            minusScors: 12000,
            privilege: [4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 15,
                color: '玫红色',
                expression: 8
            }
        }, {
            level: 17,
            name:'亲王',
            totalScore: 50000,
            get_score:	100000,
            safeScore: 10000,
            minusScors: 12000,
            privilege: [4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 20,
                color: '玫红色',
                expression: 8
            }
        }, {
            level: 18,
            name:'国王',
            totalScore: 50000,
            get_score:	150000,
            safeScore: 15000,
            minusScors: 30000,
            privilege: [4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 20,
                color: '玫红色',
                expression: 8,
                blackcard: '荣耀'
            }
        }, {
            level: 19,
            name:'皇帝',
            totalScore: 100000,
            get_score:	200000,
            safeScore: 20000,
            minusScors: 30000,
            privilege: [5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 20,
                color: '玫红色',
                expression: 8,
                blackcard: '荣耀'
            }
        }, {
            level: 20,
            name:'大帝',
            totalScore: 200000,
            get_score:	300000,
            safeScore: 20000,
            minusScors: 40000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 25,
                color: '玫红色',
                expression: 8,
                blackcard: '荣耀'
            }
        }, {
            level: 21,
            name:'帝王',
            totalScore: 200000,
            get_score:	500000,
            safeScore: 20000,
            minusScors: 40000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 25,
                color: '玫红色',
                expression: 8,
                blackcard: '荣耀'
            }
        }, {
            level: 22,
            name:'帝尊',
            totalScore: 300000,
            get_score:	700000,
            safeScore: 25000,
            minusScors: 40000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 25,
                color: '紫色',
                expression: 8,
                blackcard: '至尊'
            }
        }, {
            level: 23,
            name:'圣尊',
            totalScore: 500000,
            get_score:	1000000,
            safeScore: 25000,
            minusScors: 50000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 30,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }, {
            level: 24,
            name:'上神',
            totalScore: 500000,
            get_score:	1500000,
            safeScore: 25000,
            minusScors: 50000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 30,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }, {
            level: 25,
            name:'天神',
            totalScore: 1000000,
            get_score:	2000000,
            safeScore: 30000,
            minusScors: 50000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 30,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }, {
            level: 26,
            name:'神皇',
            totalScore: 1000000,
            get_score:	3000000,
            safeScore: 40000,
            minusScors: 100000,
            privilege: [ 2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 35,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }, {
            level: 27,
            name:'神尊',
            totalScore: 1000000,
            get_score:	4000000,
            safeScore: 50000,
            minusScors: 100000,
            privilege: [2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 35,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }, {
            level: 28,
            name:'天尊',
            totalScore: 1500000,
            get_score:	5000000,
            safeScore: 100000,
            minusScors: 100000,
            privilege: [ 2, 5, 4, 6, 8, 9, 10, 16, 7, 11],
            num: {
                flower: 35,
                color: '紫色',
                expression: 12,
                blackcard: '至尊'
            }
        }
    ],
    privilege: {
        //1: {
        //    title: '踢人',
        //    info: '大长腿想踢谁就踢谁'
        //},
        2: {
            title: '防踢',
            info: '铁屁股你就是踢不动'
        },
        //3: {
        //    title: '禁言',
        //    info: '让你话多shut up  '
        //},
        4: {
            title: '防禁言',
            info: '想说啥就说啥'
        },
        5: {
            title: '贵族隐身',
            info: '就是喜欢逗主播玩'
        },
        6: {
            title: '贵族标识隐身',
            info: '咱是有身份的人'
        },
        7: {
            title: '聊天文字颜色',
            info: '说话都那么贵气'
        },
        8: {
            title: '专属表情',
            info: '不一样的表达'
        },
        9: {
            title: '专属贵族标识',
            info: '咱是有身份的人'
        },
        10: {
            title: '排名靠前',
            info: '就是高高在上'
        },
        11: {
            title: '鲜花数量',
            info: '花的海洋'
        },
        //12: {
        //    title: '自动回复',
        //    info: '就是这么智能'
        //},
        //13: {
        //    title: '随意进入满员房间',
        //    info: '咱有有专属VIP通道'
        //},
        //14: {
        //    title: '屏蔽房间广告',
        //    info: '世界一下就清净了'
        //},
        //15: {
        //    title: '黑卡会员资格',
        //    info: 'VIP中的VIP '
        //},
        16: {
            title: '进房间欢迎特效',
            info: '进房间欢迎特效'
        }
    }
}



// WEBPACK FOOTER //
// ./src/libs/nobility.js